import { IconName } from '@blueprintjs/icons';
import React, { ReactNode } from 'react';
import Box, { BoxProps } from 'ui-box';
import { majorScale, Card, minorScale, Icon, defaultColors, Heading } from '.';

export interface IPageHeaderProps extends BoxProps<any> {
  title: ReactNode;
  type?: string;
  typeIcon?: IconName;
  thumbnail?: string | null;
  thumbnailRound?: boolean;
  thumbnailPlaceholder?: ReactNode;
  actions?: ReactNode;
  id?: string | number;
}

export const PageHeader: React.FC<IPageHeaderProps> = ({
  title,
  type,
  typeIcon,
  thumbnail,
  thumbnailRound = false,
  thumbnailPlaceholder,
  actions,
  id,
  ...props
}) => (
  <Box
    display="flex"
    alignItems="flex-end"
    justifyContent="flex-start"
    className="border-bottom"
    paddingBottom={majorScale(2)}
    marginBottom={majorScale(4)}
    {...props}
  >
    {thumbnail !== undefined && (
      <Card
        height={majorScale(8)}
        width={majorScale(8)}
        marginRight={majorScale(1)}
        borderRadius={thumbnailRound ? majorScale(4) : undefined}
        overflow="hidden"
        position="relative"
      >
        {thumbnailPlaceholder && (
          <Box
            width="100%"
            height="100%"
            display="flex"
            alignItems="center"
            className="muted p medium"
            justifyContent="center"
            position="absolute"
          >
            {thumbnailPlaceholder}
          </Box>
        )}
        {thumbnail && (
          <img
            src={thumbnail}
            alt=""
            onError={(e: any) => (e.target.style.display = 'none')}
            style={{
              objectFit: 'contain',
              width: '100%',
              height: '100%',
              position: 'absolute',
            }}
          />
        )}
      </Card>
    )}
    <Box>
      {type && (
        <Box display="flex" alignItems="flex-end" marginBottom={minorScale(1)}>
          {typeIcon && (
            <Icon
              icon={typeIcon}
              marginRight={minorScale(1.5)}
              color={defaultColors.gray[400]}
            />
          )}
          <Heading size={100}>{type}</Heading>
        </Box>
      )}
      {typeof title === 'string' ? (
        <Heading size={600}>{title}</Heading>
      ) : (
        title
      )}
    </Box>

    {(actions || id !== undefined) && (
      <Box marginLeft="auto">
        <Box display="flex" flexDirection="column" alignItems="flex-end">
          {id !== undefined && (
            <Box
              marginBottom={majorScale(1)}
              className="p font-mono"
              color={defaultColors.gray[400]}
              fontWeight={600}
            >
              <Icon
                icon="key"
                size={12}
                color={defaultColors.gray[400]}
                marginRight={minorScale(1)}
              />
              {id}
            </Box>
          )}
          <Box display="flex">{actions}</Box>
        </Box>
      </Box>
    )}
  </Box>
);
